import $ from 'jquery'
import store_finance from '@/store/mods/finances/finance.js'

export default {
    name: 'examen-bio-modal',
    components: {},
    props: {
        is_new_bulletin: Boolean,
        edit_bulletin: Object,
        analyse_to_be_deleted: Object,
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        info_user: Object,
        societe_souscripteur: {
            type: String,
            default: () => ("")
        },
        assurance: {
            type: String,
            default: () => ("")
        },
    },
    data() {
        return {
            save_loading: false,

            choix_type_demande: 'interne',
            can_show_analyse: false,
            renseignement_clinique: '',

            can_save: false,
            choice_is_empty: false,
            selected_analyse: [],

            existing_analyses: [],

            del_loading: false,
            is_confirm: false,

            is_error: false,
            permission_is_denied: false,
            patient_id: '',

            error_message: '',

            filter_analyse: '',
            filtered_analyses: [],
            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            anl_is_loading: true,
            anl_is_empty: false,
            warning_message: ''
        }
    },

    watch: {
        edit_bulletin() {
            this.permission_is_denied = false
            this.is_error = false
            this.renseignement_clinique = this.edit_bulletin.renseignement_clinique
            this.is_confirm = false

            this.each_cat_is_checked = []
            this.warning_message = ''

            let cfrm = document.getElementById('cfrm-del-bull') 
            if (cfrm && cfrm.checked) {
                cfrm.checked = false
            }
        },

        filter_analyse() {
            this.filterAnalyse()
        },

        // selected_analyse() {
        //     setTimeout(() => {
        //         this.filter_analyse = ''
        //     }, 700);
        // }
    },

    computed: {
        categoriesAnalyses() {
            return this.$store.getters["categoriesAnalyses"];
        },
    },

    mounted() {
        this.fetchAnalyse()
        this.$store.dispatch("getExamens");

        this.patient_id = this.$route.params.id
    },

    methods: {
        fetchAnalyse() {
            this.anl_is_loading = true
            this.$store.dispatch("getCategoriesAnalyses").then(() => {
                if (this.categoriesAnalyses.length == 0) {
                    this.anl_is_empty = true
                } else {
                    this.anl_is_empty = false
                    this.filtered_analyses = this.categoriesAnalyses
                }

                this.anl_is_loading = false
            })
        },

        filterAnalyse() {
            this.filtered_analyses = [];

            if (this.filter_analyse == '') {
                this.filtered_analyses = this.categoriesAnalyses
            } else {
                this.categoriesAnalyses.forEach((categorie_analyse) => {
                    categorie_analyse.analyses.forEach(analyse => {
                        let cleaned_analyse = this.removeAccents(analyse.nom)
                        let cleaned_filter = this.removeAccents(this.filter_analyse)
    
                        if (cleaned_analyse.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_analyses.push(analyse)
                        }
                    });
                });
            }
        },

        onChoice(value) {
            if (value == 1) {
                this.can_show_analyse = true
            } else {
                this.can_show_analyse = false
            }
            
        },

        checkIfExistInBulletin() {
            this.edit_bulletin.analyses.forEach(sl => {
                var bull = this.selected_analyse.filter((el) => {
                    return el.id != sl.analyse_id
                })

                this.selected_analyse = bull
            });
        },

        toggleRenseignement(v) {
            if (v) {
                if (this.selected_analyse.length == 0) {
                    this.choice_is_empty = true
                    return
                }
            }

            this.can_save = v
        },

        clearError() {
            this.choice_is_empty = false
        },

        //Request pour demander une analyse
        async demandeAnalyse() {
            this.warning_message = ''
            if (!this.is_new_bulletin) {
                /**
                 * Deselectionner les analyse déjà existantes
                 */
                this.checkIfExistInBulletin()

                if (this.selected_analyse.length == 0) {
                    this.warning_message = "Impossible d'ajouter la même analyse à ce bulletin d'analyse."
                }
            }

            if (this.$refs.renseign_form) {
                const isValid = await this.$refs.renseign_form.validate();

                if (!isValid) {
                    return;
                }
            }


            this.selected_analyse = this.setPrestationUID(this.selected_analyse)
            const data = {
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                analyses: this.selected_analyse,
                user_id: this.user_id,
                user: this.info_user,
                choix_type_demande: this.choix_type_demande, 
                renseignement_clinique: this.renseignement_clinique,
                bulletin_id: this.edit_bulletin.bulletin_id,
                patient_id: this.patient_id,
                type_prestation: 'Analyses',
                can_set_pac: this.can_set_pac,
                info_patient: this.info_patient,
                info_caissier: this.info_caissier,
                medecin_demandeur: {
                    medecin_nom: this.info_caissier.nom_caissier,
                    titre: this.info_caissier.titre
                },
                nom_patient: this.info_patient.nom_patient,
                sexe: this.info_patient.sexe,
                telephone: this.info_patient.telephone,
                societe_souscripteur: this.societe_souscripteur,
                assurance: this.assurance
            }

            if (data.analyses.length == 0) {
                return
            }

            if (this.is_new_bulletin && this.renseignement_clinique == '') {
                return 
            }

            this.save_loading = true

            if (data.analyses.length > 0) {
                this.$store.dispatch('saveBulletinAnalyse', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')
                        this.$emit("emitBulletinAnalyse")

                        this.renseignement_clinique = ''
                        this.selected_analyse = []
                        this.each_cat_is_checked = []
                        this.can_save = false
                        this.$refs.bull_analyse_mdl.click()

                        store_finance.storeLigneOperation(response.data).then((finance_response) => {
                            if (!finance_response.success) {
                                this.errorToast(finance_response.message)
                                return;
                            } 
                        }).catch(() => {
                            this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                        })
                    } else {
                        if (response.code === 500) {
                            this.is_error = true
                        } else if (response === 403) {
                            this.permission_is_denied = true
                        }
                    }
    
                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.is_error = true
                })
            }
        }, 

        async submit() {
            const isValid = await this.$refs.r_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            let data = {
                consultation_id: this.consultation_id,
                evolution_id: this.edit_bulletin.evolution_id,
                bulletin_id: this.edit_bulletin.bulletin_id,
                renseignement_clinique: this.renseignement_clinique,
                user_id: this.user_id,
            }

            this.$store.dispatch('editRenseignementClinique', data).then((response) => {
                if (response > 0) {
                    this.renseignement_clinique = ''
                    this.$refs.r_form.reset()
                    this.$refs.edit_renseign.click()

                    this.$emit("emitBulletinAnalyse")
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.error_message = ''
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { 
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                consultation_id: this.consultation_id,
                bulletin_id: this.edit_bulletin.bulletin_id,
                user_id: this.user_id,
            }

            this.del_loading = true;
            this.$store.dispatch('deleteBulletinAnalyse', data).then((response) => {
                if (response.success) {
                    this.successToast("Bulletin d'analyse supprimé avec succès")
                    this.$emit('emitBulletinAnalyse')

                    this.is_confirm = false
                    this.$refs.del_bulletin.click();

                    store_finance.removeAllItemsFromCaisse(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    if (response.code == 403) {         // Permission denied
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 409) {
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },

        deleteAnalyse(selector) {
            this.error_message = ''
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            
            this.$store.dispatch('deleteDemandeAnalyse', this.analyse_to_be_deleted).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit('emitBulletinAnalyse')

                    this.$refs.del_analyse.click()

                    store_finance.removeItemFromCaisse(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    if (response.code == 403) {         // Permission denied
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 409) {
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#catanl-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.categoriesAnalyses.forEach((categorie_analyse) => {
                if (categorie_analyse.id == index) {
                    categorie_analyse.analyses.forEach((_data) => {
                        this.text_grey[_data.id] = (is_checked)?'text-grey':''

                        const tmp_analyse = {
                            id: _data.id,
                            nom: _data.nom,
                            prix: _data.prix
                        }
                        if (is_checked) {
                            this.selected_analyse.push(tmp_analyse)
                        } else {
                            this.selected_analyse = this.selected_analyse.filter(item => item.id != tmp_analyse.id)
                        }
                    })
                }
            });
        },
    }
}